import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FormAuthentication } from "../../components/Auth/Form";
import Cookies from "../../components/Cookies";
import Footer from "../../components/Footer";
import LoadingSpinner from "../../components/LoadingSpinner";
import Header from "../../components/Sign/Header";
import { getInfoAuth } from "../../service/getInfoAuth";
import { getToken } from "../../service/getToken";
import { Section } from "../../styled";

const Auth = () => {
  const [documentName, setDocumentName] = useState<string>("");
  const [signingDeadline, setSigningDeadline] = useState<string>("");
  const [reason, setReason] = useState<string>("");
  const [requester, setRequester] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<number>(0);

  const url = window.location.search;
  const urlParams = new URLSearchParams(url);
  const id = urlParams.get("id");
  const urlSettings = `${process.env.REACT_APP_PATHNAME}settings?id=${id}`;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await getToken();
      setIsLoading(true);
      try {
        const data = await getInfoAuth();
        setDocumentName(data.document_name);
        setSigningDeadline(data.signing_deadline);
        setReason(data.reason);
        setRequester(data.requester);

        if (data.token_signatory) {
          Swal.fire({
            title: "Atenção!",
            text: "Faça seu cadastro para realizar a assinatura!",
            icon: "warning",
            confirmButtonText: "OK",
            confirmButtonColor: "#77EC84",
          }).then(() => {
            navigate(urlSettings);
          });
          sessionStorage.setItem("token_signatory", data.token_signatory);
          sessionStorage.setItem("signature_request", data.signature_request);
          sessionStorage.setItem("user_email", data.user_email);
        }

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Erro ao renderizar o PDF", error);
      }
    };
    fetchData();
  }, [navigate, urlSettings]);

  const handleStepChange = () => {
    setCurrentStep(1);
  };

  return (
    <Section>
      {isLoading && <LoadingSpinner />}
      <Header visible={true} currentStep={currentStep} />
      <FormAuthentication
        documentName={documentName}
        signingDeadline={signingDeadline}
        reason={reason}
        requester={requester}
        onVerificationSuccess={handleStepChange}
      />
      <Cookies />
      <Footer isAbsolute={true} />
    </Section>
  );
};

export default Auth;
